module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-use-shopping-cart/gatsby-browser.js'),
      options: {"plugins":[],"mode":"payment","cartMode":"checkout-session","stripePublicKey":"\"\"","currency":"EUR","successUrl":"https://useshoppingcart.com/","cancelUrl":"https://stripe.com/","allowedCountries":["US","GB","CA"],"billingAddressCollection":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-TS2KTM3","includeInDevelopment":false,"defaultDataLayer":null,"routeChangeEventName":"gatsby-route-change","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com"},
    },{
      plugin: require('../node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
